/**
 * The co-pilot's checklist, for the surfaces that only READ it.
 *
 * The same shape as `useCrmLabels` and for the same reason: it is one small
 * registry the whole desk shares, so it is fetched once by the section rather
 * than once per call pane, and a call switched in the list does not re-request
 * a list that cannot have changed.
 *
 * Failure is silent. Coverage is a nice thing to see on a finished call and
 * nothing depends on it, so a desk whose checklist request failed shows the call
 * without the block instead of an error about a list the operator did not ask
 * for. `coverageOf` already draws nothing for an empty list, so the failure and
 * the "we do not score calls" setting land in the same place.
 */
import { useEffect, useState } from "react";
import { getPilotChecklist, type PilotChecklistItem } from "../lib/callPilot";

export function usePilotChecklist(): { checklist: PilotChecklistItem[] } {
  const [checklist, setChecklist] = useState<PilotChecklistItem[]>([]);

  useEffect(() => {
    let alive = true;
    getPilotChecklist()
      .then((res) => {
        if (alive) setChecklist(res.items);
      })
      .catch(() => {
        /* the desk works without the checklist */
      });
    return () => {
      alive = false;
    };
  }, []);

  return { checklist };
}
